export default function () {

  $(window).scroll(function () {
    if ($(this).scrollTop() > 200) {
      $('#back-to-top').fadeIn();
    } else {
      $('#back-to-top').fadeOut();
    }
  });

  $('#back-to-top').tooltip('show');

  $('#back-to-top').on('click', function (e) {
    e.preventDefault();

    $(this).tooltip('hide');

    $('body,html').animate({
      scrollTop: 0
    }, 500);
  });

}


// WEBPACK FOOTER //
// ./js/modules/back-to-top.js